import {Component, OnInit, ViewChild, Inject} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

import {map, tap} from 'rxjs/operators';
import {
  EntityServiceClient,
  LevelDto,
  LevelFilterDto,
  LevelServiceClient,
  PredictionModelFilterDto,
  ReferenceFilterDto
} from '@sharedrest/data.restservice';
import {NeqSelectAutocompleteComponent} from '@sharedcommon/components/select-autocomplete/neq-select-autocomplete.component';
import {UserService} from '@sharedcommon/services/user.service';
import {Constants} from '@sharedcommon/util/constants.util';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TreeNode} from 'primeng/api';
import { lastValueFrom } from 'rxjs';

@Component({
  templateUrl: 'advanced-references-search-popin.component.html'
})
export class NeqAdvancedReferencesSearchPopinComponent implements OnInit {

  @ViewChild('predictionModelSelectAutocomplete') predictionModelSelectAutocomplete: NeqSelectAutocompleteComponent;
  @ViewChild('referenceSelectAutocomplete') referenceSelectAutocomplete: NeqSelectAutocompleteComponent;



  form = new FormGroup({
    level: new FormControl(),
    predictionModel: new FormControl(),
    reference: new FormControl()
  });
  levels: LevelDto[] = [];
  predictionModelsNumber = 0;
  referencesNumber = 0;
  isSubmitDisabled = true;
  selectedLevel: TreeNode;

  constructor(
    private readonly userService: UserService,
    private readonly entityService: EntityServiceClient,
    private readonly levelService: LevelServiceClient,
    private readonly dialogRef: MatDialogRef<NeqAdvancedReferencesSearchPopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string}
  ) {}

  ngOnInit() {
    this.form.get('level').valueChanges.subscribe(() => this.onLevelSelected());
    this.form.get('predictionModel').valueChanges.subscribe(() => this.onPredictionModelChange());
    this.form.get('reference').valueChanges.subscribe(() => this.onReferenceChange());

    const filter = new LevelFilterDto();
    filter.page = Constants.ALL_PAGE;
    filter.withChildren = true;
    filter.depth = 2;
    filter.minDepth = 2;
    this.levelService.fetch(filter).subscribe(levels => this.levels = levels.data);
  }

  onLevelSelected() {
    this.predictionModelSelectAutocomplete.reset();
  }

  filterLevels = (item: LevelDto, filter: string) => {
    return item && item.label.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
  };

  predictionModelsDatasource = (searchTerm, page) => {
    const filter = new PredictionModelFilterDto();
    if (searchTerm) {
      filter.matchAny = true;
      filter.code = searchTerm;
      filter.label = searchTerm;
    }
    const selectedLevel = this.form.get('level').value;
    if (selectedLevel) {
      filter.inLevelIds = [selectedLevel.id];
    }
    filter.page = page;
    filter.count = 10;
    filter.sort = [];
    return lastValueFrom(
      this.entityService.predictionModelsFetch(this.userService.getEntity(), filter).pipe(
        tap(result => this.predictionModelsNumber = result.total),
        map(result =>
          result.data.map(predictionModel => {
            return {
              label: `${predictionModel.code} - ${predictionModel.label} (${predictionModel.description})`,
              value: predictionModel
            };
          })
        )
      )
    );
  }

  onPredictionModelChange() {
    this.referenceSelectAutocomplete.reset();
  }

  referencesDatasource = (searchTerm: string, page) => {
    const filter = new ReferenceFilterDto();

    if (searchTerm) {
      filter.matchAny = true;
      filter.code = searchTerm;
      filter.label = searchTerm;
    }

    const selectedPredictionModel = this.form.get('predictionModel').value;
    if (selectedPredictionModel) {
      filter.inPredictionModelIds = [selectedPredictionModel.value.id];
    } else {
      const selectedLevel = this.form.get('level').value;
      if (selectedLevel) {
        filter.inLevelIds = [selectedLevel.id];
      }
    }

    filter.page = page;
    filter.count = 10;
    filter.sort = [];

    const restResponse = this.entityService.referencesFetch(this.userService.getEntity(), filter);

    return lastValueFrom(
      restResponse.pipe(
        tap(result => this.referencesNumber = result.total),
        map(result =>
          result.data.map(reference => {
            return {
              label: `${reference.code} - ${reference.label} (${reference.description})`,
              value: reference
            };
          })
        )
      )
    );
  };

  onReferenceChange() {
    this.isSubmitDisabled = !this.form.get('reference').value;
  }

  onFormSubmit() {
    this.dialogRef.close(this.form.get('reference').value);
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  nodeSelect() {
    if (this.selectedLevel && this.selectedLevel.children === null) {
      const level = {...this.selectedLevel};
      level.parent = null;
      level.children = null;
      this.form.get('level').patchValue(level);
      this.form.get('level').updateValueAndValidity();
    } else {
      this.selectedLevel = null;
    }
  }
}
